<template>
    <main class="no-frontpage">        
        <div class="container">
            <Loader v-show="isLoading"/>
            <div v-show="!isLoading" class="row">
                <div class="col-md-9 col-xs-12">
                    <section>
                        <h1>
                            Presupuesto por resultados
                        </h1>
                        <p>El Presupuesto por Resultados (PpR) es una estrategia de gestión  pública que permite vincular la asignación de recursos presupuestales bienes y servicios (productos) y resultados a favor de la población, con la característica de permitir que estos puedan ser medibles.</p>
                        <p>El PpR contribuye con la mejora de la calidad del gasto público al propiciar que las entidades del Estado:</p>
                        <ul class="list">
                            <li>Hagan un uso eficiente y eficaz de los recursos públicos, priorizando el gasto público en la provisión de productos (bienes y servicios) que, según la evidencia, contribuyen al logro de resultados vinculados al bienestar de la población.</li>
                            <li>Tomen mejores decisiones en materia presupuestal y de gestión, que permitan el logro de resultados a favor de la población.</li>
                        </ul>
                        <hr>
                        <h2>Los PpRs en el tiempo:</h2>
                        <Timeline :timeline="timeline"></Timeline>
                    </section>
                    <section v-if="failed">
                        <Error :error="error" />
                    </section>
                </div>
                <div class="col-md-3 col-xs-12">
                    <slot name="sidebar">Can not charge the sidebar :(</slot>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import {getTimeline} from '@/api.js';
import Timeline from '@/components/TimeLine/Timeline.vue'
import Loader from '@/components/Loader.vue'
import Error from '@/components/Error.vue';
export default {
    name: "Home",
    data() {
        return {
            isLoading: true,
            timeline: [],
            failed: false,
            error: {}
        }
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {
            await getTimeline().then(data => {
                this.timeline = data.timeline;
                this.isLoading = false;
            })
            .catch(() => {
                this.error.title = "ERROR";
                this.error.message = "El recurso que está buscando no se encuentra disponible en este momento";
                this.isLoading = false;
                this.failed = true;
            })
        }
    },
    components: { 
        Timeline,
        Loader,
        Error 
    }
};
</script>
